"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingTransaction = void 0;
var account_1 = require("../account");
/** Проводка - перевод средств с одного счёта на другой */
var BillingTransaction = /** @class */function () {
  function BillingTransaction(values) {
    if (values === void 0) {
      values = {};
    }
    var properties = ['id', 'operation', 'is_accountable', 'operation_id', 'from_billing_profile_id', 'from_balance_id', 'to_billing_profile_id', 'to_balance_id', 'amount', 'currency_id', 'details', 'created_at', 'status', 'billing_operation_id'];
    var instance = this;
    properties.forEach(function (p) {
      if (p in values) {
        instance[p] = values[p];
      }
    });
    instance.created_at = values.created_at instanceof Date ? values.created_at : new Date(values.created_at);
    instance.currency = account_1.currencies[values.currency_id];
  }
  return BillingTransaction;
}();
exports.BillingTransaction = BillingTransaction;
